<template>
  <FormModal title="Gaat het om binnen- of buitenschilderwerk?" show-back-btn>
    <template #body>
      <IndoorOrOutdoorFormStep :progress-value="progressValue" />
    </template>
  </FormModal>
</template>

<script>
import FormModal from 'chimera/all/themes/blueflow/components/layout/FormModal'
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import { useExperiments } from 'chimera/all/composables/useExperiments'
import { PD_10118_REMOVE_PAINTING_QUESTIONS } from 'chimera/all/constants/experiments'
import IndoorOrOutdoorFormStep from '~/components/form/steps/indoorOrOutdoor/IndoorOrOutdoorFormStep'

export default {
  components: {
    IndoorOrOutdoorFormStep,
    FormModal,
  },

  extends: AbstractFormPage,

  layout: 'form',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Gaat het om binnen- of buitenschilderwerk?',
      headDescription: 'Geef aan waar geschilderd moet worden.',
      path: '/offertes-aanvragen/binnen-of-buiten-schilderwerk',
      progressValue: 51,
    }
  },

  /**
   * Set checkoutStep based on experiment variant.
   */
  mounted() {
    const { getFromStore, isVariant } = useExperiments(this.$store)
    this.setCheckoutStep(
      isVariant(getFromStore(PD_10118_REMOVE_PAINTING_QUESTIONS), 1) ? 2 : 3,
    )
  },
}
</script>
